<div class="ui-g loyality-movement">

  <div class="ui-g-12" *ngIf="show.datatable && srvCalTranslate.pcalendarTranslate.dateFormat">

    <app-kontable #table *ngIf="customerHideInfoPermission"
      title = "{{columnsTitles.movement}}"
      [columns] = "[
      { field: 'card_no', title: columnsTitles.card_no },
      { field: 'xact_date', title: columnsTitles.xact_date, filterChars: 10, filterTemplate: dateCustomFilter, filterType: customFilter },
      { field: 'xact_time', filterTemplate: noFilter, title: columnsTitles.xact_time, filterType: noFilter ,bodyTemplate: time },
      { field: 'customerId', bodyTemplate: customerTemplate, filterType: noFilter, title: columnsTitles.customer_id,  textAlignment: 'left' },
      { field: 'storeDescription',  title: columnsTitles.storeDescription, textAlignment: 'left' },
      { field: 'cash_desk', filterTemplate: noFilter, title: columnsTitles.cash_desk, filterType: noFilter, textAlignment: 'center' },
      { field: 'reasonDescription',filterType: selectFilter, filterOptions: { values: listReason }, title: columnsTitles.reasonDescription, textAlignment: 'left' },
      { field: 'value', filterTemplate: noFilter, title: columnsTitles.value, filterType: noFilter, textAlignment: 'right' },
      { field: 'acm_code',title: 'common.acm' ,filterType: customFilter, filterTemplate: acmCustomFilter, bodyTemplate: acmDescriptionRow}
      ]"
      [reportColumnWidth]="[100, 150, 80, 65, 125, 60, 145, 65, 80]"
      [reportColumnType]="['STANDARD','STANDARD','DATE','TIME','STANDARD','STANDARD','STANDARD','STANDARD']"
      [reportColumnAlignment]="['left', 'left', 'center', 'center', 'left', 'center', 'left', 'right']"
      [paginationType]="paginationType"
      [showInfoButton]="true"
      [showRecoverButton]="true"
      [showGlobalFilter]="false"
      [showAddButton]="true"
      [showEditButton]="false"
      [showDeleteButton]="false"
      [service]="movementService"
      (onDetails)="onOpen($event)"
      (onAdd)="onAddNew($event)"
      (onEdit)="onEdit($event)"
      (onRemove)="onRemove($event)"
      (onClearFilters)="onClearFilters($event)"
      [toolbarCustomButtons]="customButton"
      [filterBySingleColumn]="false"
    >

      <ng-template #acmDescriptionRow  let-row>
        <span>
          {{row.acm_code + ' - ' + row.acm_description}}
        </span>
      </ng-template>
      <ng-template #customButton>

        <button *ngIf="!hideBtnImportMovementPermission" pButton type="button" class="k-generic-btn" icon="fa fa-upload" iconPos="left" label="{{ 'loyalty.movementsImport' | translate }}"
                (click)="goToImportMovement()" style="margin-top: 7px; margin-left: 10px; height: 34px !important;"></button>
      </ng-template>

      <ng-template #acmCustomFilter data-testid="acmCustomFilter" let-col>
        <p-dropdown [options]="listAcm" [filter]="true" filterBy="label" [style]="{'width':'100%'}"
          [(ngModel)]="filterAcmSelected"
          (onChange)="table.updateTableFilter('acm_code', $event.value, 'equals')"></p-dropdown>
      </ng-template>

      <ng-template #dateCustomFilter data-testid="dateCustomFilter" let-col>
        <p-calendar class="calendarKontable"
        dateFormat="{{srvCalTranslate.pcalendarTranslate.dateFormat}}"
        dataType="date"
        [(ngModel)]="model.filterXactDate"
        [monthNavigator]="true"
        [yearNavigator]="true"
        [yearRange]="'1900:2099'"
        (ngModelChange)="onChangeXactDate('xact_date')"
        (onClearClick)="onChangeXactDate('xact_date')"
        [inputStyle]="{'width':'100%', 'height':'26px', 'border-color':'#fec55c'}"
        [readonlyInput]="true"
        showButtonBar="true">
        </p-calendar>
      </ng-template>

      <ng-template #noFilter data-testid="noFilter" let-col>

      </ng-template>

      <ng-template #time data-testid="time" let-row>
        <span>{{row.xact_time.slice(0, 8)}}</span>
      </ng-template>

      <ng-template #reasonCustomFilter data-testid="reasonCustomFilter" let-col>
        <p-dropdown [options]="listReason" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter('store_id', $event.value, 'equals')"></p-dropdown>
      </ng-template>

      <ng-template #statusTemplate data-testid="statusTemplate" let-row class="deleted-row">
        <span *ngIf="row.customerState && row.flg_state == '1'" class="fa fa-trash-o" title="{{'common.deleted' | translate}}"></span>
        <span *ngIf="row.customerState && row.flg_state == '2'" class="fa fa-ban" title="{{'common.suspended' | translate}}"></span>
      </ng-template>

      <ng-template #customerTemplate data-testid="customerTemplate" let-row>
        <span>{{row.customerCode }} - {{row.customerName }}  {{row.customerSurname }} </span>
      </ng-template>

      <ng-template #acmTemplate data-testid="acmTemplate" let-row>
          <span>{{row.acm_code }} - {{row.acm_description }}</span>
      </ng-template>

      <ng-template #statusCustomFilter data-testid="statusCustomFilter" let-col>
        <p-dropdown [options]="listStatus" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter('store_id', $event.value, 'equals')"></p-dropdown>
      </ng-template>
    </app-kontable>

    <app-kontable #table *ngIf="!customerHideInfoPermission"
      title = "{{columnsTitles.movement}}"
      [columns] = "[
      { field: 'card_no', title: columnsTitles.card_no },
      { field: 'xact_date', title: columnsTitles.xact_date, filterChars: 10, filterTemplate: dateCustomFilter, filterType: customFilter },
      { field: 'xact_time', filterTemplate: noFilter, title: columnsTitles.xact_time, filterType: noFilter ,bodyTemplate: time },
      { field: 'customerId', bodyTemplate: customerTemplate, filterType: noFilter, title: columnsTitles.customer_id,  textAlignment: 'left' },
      { field: 'storeDescription',  title: columnsTitles.storeDescription, textAlignment: 'left' },
      { field: 'cash_desk', filterTemplate: noFilter, title: columnsTitles.cash_desk, filterType: noFilter, textAlignment: 'center' },
      { field: 'reason_id', filterType: selectFilter,  filterOptions: { values: listReason }, title: columnsTitles.reasonDescription, bodyTemplate: reasonTemplate },
      { field: 'value', filterTemplate: noFilter, title: columnsTitles.value, filterType: noFilter, textAlignment: 'right' },
      { field: 'acm_code',title: 'common.acm' ,filterType: customFilter, filterTemplate: acmCustomFilter, bodyTemplate: acmDescriptionRow}

      ]"
      [reportColumnWidth]="[100, 150, 80, 65, 125, 60, 145, 65, 80]"
      [reportColumnType]="['STANDARD','STANDARD','DATE','TIME','STANDARD','STANDARD','STANDARD','STANDARD']"
      [reportColumnAlignment]="['left', 'left', 'center', 'center', 'left', 'center', 'left', 'right']"
      [paginationType]="paginationType"
      [showInfoButton]="true"
      [showRecoverButton]="true"
      [showGlobalFilter]="false"
      [showAddButton]="true"
      [showEditButton]="false"
      [showDeleteButton]="false"
      [service]="movementService"
      (onDetails)="onOpen($event)"
      (onAdd)="onAddNew($event)"
      (onEdit)="onEdit($event)"
      (onRemove)="onRemove($event)"
      (onClearFilters)="onClearFilters($event)"
      [toolbarCustomButtons]="customButton"
      [filterBySingleColumn]="false"
    >

      <ng-template #reasonTemplate let-row>
        <span>
          {{row.reasonDescription}}
        </span>
      </ng-template>
      <ng-template  #acmDescriptionRow   let-row>
        <span>
          {{row.acm_code + ' - ' + row.acm_description}}
        </span>
      </ng-template>
      <ng-template #customButton>

        <button *ngIf="!hideBtnImportMovementPermission" pButton type="button" class="k-generic-btn" icon="fa fa-upload" iconPos="left" label="{{ 'loyalty.movementsImport' | translate }}"
                (click)="goToImportMovement()" style="margin-top: 7px; margin-left: 10px; height: 34px !important;"></button>
      </ng-template>

      <ng-template #acmCustomFilter data-testid="acmCustomFilter" let-col>
        <p-dropdown [options]="listAcm" [filter]="true" filterBy="label" [style]="{'width':'100%'}"
          [(ngModel)]="filterAcmSelected"
          (onChange)="table.updateTableFilter('acm_code', $event.value, 'equals')"></p-dropdown>
      </ng-template>


      <ng-template #dateCustomFilter data-testid="dateCustomFilter" let-col>
        <p-calendar class="calendarKontable"
        dateFormat="{{srvCalTranslate.pcalendarTranslate.dateFormat}}"
        dataType="date"
        [(ngModel)]="model.filterXactDate"
        [monthNavigator]="true"
        [yearNavigator]="true"
        [yearRange]="'1900:2099'"
        (ngModelChange)="onChangeXactDate('xact_date')"
        (onClearClick)="onChangeXactDate('xact_date')"
        [inputStyle]="{'width':'100%', 'height':'26px', 'border-color':'#fec55c'}"
        [readonlyInput]="true"
        showButtonBar="true">
        </p-calendar>
      </ng-template>

      <ng-template #noFilter data-testid="noFilter" let-col>

      </ng-template>

      <ng-template #time data-testid="time" let-row>
        <span>{{row.xact_time.slice(0, 8)}}</span>
      </ng-template>

      <ng-template #reasonCustomFilter data-testid="reasonCustomFilter" let-col>
        <p-dropdown [options]="listReason" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter('store_id', $event.value, 'equals')"></p-dropdown>
      </ng-template>

      <ng-template #statusTemplate data-testid="statusTemplate" let-row class="deleted-row">
        <span *ngIf="row.customerState && row.flg_state == '1'" class="fa fa-trash-o" title="{{'common.deleted' | translate}}"></span>
        <span *ngIf="row.customerState && row.flg_state == '2'" class="fa fa-ban" title="{{'common.suspended' | translate}}"></span>
      </ng-template>

      <ng-template #customerTemplate data-testid="customerTemplate" let-row>
        <span>{{row.customerCode }} - {{row.customerName }}  {{row.customerSurname }} </span>
      </ng-template>

      <ng-template #acmTemplate data-testid="acmTemplate" let-row>
          <span>{{row.acm_code }} - {{row.acm_description }}</span>
      </ng-template>

      <ng-template #statusCustomFilter data-testid="statusCustomFilter" let-col>
        <p-dropdown [options]="listStatus" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter('store_id', $event.value, 'equals')"></p-dropdown>
      </ng-template>
    </app-kontable>

  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-movement/loyalty-movement.component.html